// frontend/admin-portal/src/services/purchaseOrderService.js
import api from './axiosConfig';

export const purchaseOrderService = {
    list: async (params = {}) => {
        const { data } = await api.get('/purchase-orders', { params });
        return data.data;
    },
    stats: async () => {
        const { data } = await api.get('/purchase-orders/stats');
        return data.data;
    },
    get: async (id) => {
        const { data } = await api.get(`/purchase-orders/${id}`);
        return data.data.purchaseOrder;
    },
    awardQuotation: async (payload) => {
        const { data } = await api.post('/purchase-orders/award', payload);
        return data.data.purchaseOrder;
    },
    update: async (id, payload) => {
        const { data } = await api.put(`/purchase-orders/${id}`, payload);
        return data.data.purchaseOrder;
    },
    send: async (id) => {
        const { data } = await api.patch(`/purchase-orders/${id}/send`);
        return data.data.purchaseOrder;
    },
    cancel: async (id, reason) => {
        const { data } = await api.patch(`/purchase-orders/${id}/cancel`, { reason });
        return data.data.purchaseOrder;
    },
    remove: async (id) => {
        const { data } = await api.delete(`/purchase-orders/${id}`);
        return data;
    },
    receive: async (id, payload) => {
        const { data } = await api.post(`/purchase-orders/${id}/receive`, payload);
        return data.data;
    },

    // ---- Import ----
    importPreview: async (file) => {
        const form = new FormData();
        form.append('file', file);
        const { data } = await api.post('/purchase-orders/import/preview', form, {
            headers: { 'Content-Type': 'multipart/form-data' },
            timeout: 60000,
        });
        return data.data;
    },
    importConfirm: async (payload) => {
        const { data } = await api.post('/purchase-orders/import/confirm', payload, {
            timeout: 120000,
        });
        return data.data;
    },

    downloadImportTemplate: async () => {
        const res = await api.get('/purchase-orders/import/template', {
            responseType: 'blob',
        });
        const dispo = res.headers['content-disposition'] || '';
        const match = /filename="?([^"]+)"?/i.exec(dispo);
        const filename = match?.[1] || 'fiberhome-po-import-template.csv';

        const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);

        return { filename };
    },
    // Add to purchaseOrderService
    previewAllocation: async (id) => {
        const { data } = await api.get(`/purchase-orders/${id}/allocation/preview`);
        return data.data;
    },
    allocateCosts: async (id, dryRun = false) => {
        const { data } = await api.post(`/purchase-orders/${id}/allocate-costs`, { dryRun });
        return data.data;
    },
};